import { NavLink } from 'react-router'

import { Icon, type IconName } from '@/components/icons/Icon'
import { cartCount } from '@/features/cart/selectors'
import { useCartStore } from '@/features/cart/store'

import styles from './BottomNav.module.css'

const TABS: { to: string; label: string; icon: IconName }[] = [
  { to: '/', label: 'Home', icon: 'home' },
  { to: '/shops', label: 'Shops', icon: 'store' },
  { to: '/search', label: 'Search', icon: 'search' },
  { to: '/cart', label: 'Cart', icon: 'cart' },
]

/** Mobile tab bar (hidden ≥ 900px, where the header shows top tabs). */
export function BottomNav() {
  const count = useCartStore((s) => cartCount(s.lines))
  return (
    <nav className={styles.bnav} aria-label="Tabs">
      <div className={styles.inner}>
        {TABS.map((t) => (
          <NavLink key={t.to} to={t.to} end={t.to === '/'} className={styles.tab}>
            <Icon name={t.icon} size={22} />
            {t.label}
            {t.to === '/cart' && count > 0 && (
              <span className={`${styles.badge} num`}>{count}</span>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
